import { cvApi, emptyCv } from '../../cv-builder/hooks/cvApi';
import { getResourceMap } from './learningResources';
async function activeCv(profileId) {
  const listed = await cvApi.list({scope: 'self'});
  const profiles = listed.profiles.filter(p => (p.scope || 'self') === 'self');
  const user = JSON.parse(localStorage.getItem('user') || 'null');
  const preferred = localStorage.getItem(`cv_active_${user?._id}`);
  if (profileId && !profiles.some(p => p.id === profileId)) throw new Error('Growth Planner solo admite currículums personales');
  const id = profileId || profiles.find(p => p.id === preferred)?.id || profiles[0]?.id;
  if (!id) throw new Error('Crea primero un currículum.');
  const cv = await cvApi.get(id, {scope: 'self'});
  if ((cv.scope || 'self') !== 'self' || cv.personId) throw new Error('Growth Planner solo admite currículums personales');
  return cv;
}
export async function importSkillsFromCv() {
  const cv = await activeCv();
  return cv.data.skills.filter(Boolean).map(name => ({
    name
  }));
}
export async function importCoursesFromCv() {
  const cv = await activeCv();
  return cv.data.courses.map(c => ({
    ...c,
    institution: ''
  }));
}
export async function importExperienceFromCv() {
  return (await activeCv()).data.experience;
}
export async function syncCompletedCertificationsToCv(completedItems, profileId = null) {
  const cv = await activeCv(profileId);
  const existing = cv.data.courses;
  const titles = new Set(existing.map(c => c.title));
  const additions = [];
  for (const item of completedItems) {
    if (['certification', 'course'].includes(item.type) && !titles.has(item.title)) {
      titles.add(item.title);
      additions.push({
        title: item.title,
        date: item.targetDate || new Date().toISOString().slice(0, 7)
      });
    }
  }
  if (additions.length) await cvApi.edit(cv.id, 'courses', [...existing, ...additions], cv.revision);
  return additions.length;
}
export async function syncSkillsToCv(names, profileId = null) {
  const cv = await activeCv(profileId);
  await cvApi.edit(cv.id, 'skills', [...new Set([...cv.data.skills, ...names.filter(Boolean)])], cv.revision);
}
export async function createCvProfileForRoute(route, learningResources = []) {
  const map = getResourceMap(learningResources),
    ids = new Set();
  route.stages?.forEach(s => s.items?.forEach(p => {
    if (p.resourceId) ids.add(p.resourceId);
  }));
  const skills = [...new Set([...ids].flatMap(id => map.get(id)?.skills || []).filter(Boolean))];
  const profile = await cvApi.create(`CV ${route.name}`, {
    ...emptyCv(),
    introduction: route.objective || route.description || '',
    skills
  }, {
    targetRole: route.targetRole || route.name,
    linkedRouteId: route.id
  });
  return profile.id;
}
export async function getCvProfiles() {
  return (await cvApi.list({scope: 'self'})).profiles.filter(p => (p.scope || 'self') === 'self');
}
export async function linkRouteToProfile(routeId, profileId) {
  const cv = await activeCv(profileId);
  return cvApi.command({
    action: 'meta',
    requestId: crypto.randomUUID(),
    cvId: cv.id,
    expectedRevision: cv.revision,
    changes: {
      linkedRouteId: routeId
    }
  });
}
